"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = exports.initializeDevCycle = void 0;
var Client_1 = require("./Client");
__exportStar(require("./types"), exports);
function initializeDevCycle(sdkKey, userOrOptions, optionsArg) {
    if (optionsArg === void 0) { optionsArg = {}; }
    // TODO: implement logger
    if (typeof window === 'undefined') {
        console.warn('Window is not defined, try initializing in a browser context');
    }
    var options = optionsArg;
    var isDeferred = false;
    if ((0, Client_1.isDeferredOptions)(userOrOptions)) {
        isDeferred = true;
        options = userOrOptions;
    }
    if (typeof window !== 'undefined' &&
        !window.addEventListener &&
        !(options === null || options === void 0 ? void 0 : options.reactNative)) {
        throw new Error('Window is not defined, try initializing in a browser context.' +
            ' If running on React Native, initialize with the option reactNative: true');
    }
    if ((options === null || options === void 0 ? void 0 : options.reactNative) && !globalThis.DeviceInfo) {
        throw new Error('DeviceInfo is not defined. ' +
            'Import react-native-device-info and set global.DeviceInfo when running on React Native');
    }
    if (!sdkKey) {
        throw new Error('Missing SDK key! Call initialize with a valid SDK key');
    }
    if (!isDeferred && !userOrOptions) {
        throw new Error('Missing user! Call initialize with a valid user');
    }
    if (!options || options === null) {
        throw new Error('Invalid options! Call initialize with valid options');
    }
    var client;
    if ((0, Client_1.isDeferredOptions)(userOrOptions)) {
        client = new Client_1.DevCycleClient(sdkKey, userOrOptions);
    }
    else {
        client = new Client_1.DevCycleClient(sdkKey, userOrOptions, options);
    }
    client
        .onClientInitialized()
        .then(function () { return client.logger.info('Successfully initialized DevCycle!'); })
        .catch(function (err) {
        return client.logger.error("Error initializing DevCycle: ".concat(err));
    });
    return client;
}
exports.initializeDevCycle = initializeDevCycle;
/**
 * @deprecated Use initializeDevCycle instead
 */
exports.initialize = initializeDevCycle;
exports.default = {
    initialize: exports.initialize,
    initializeDevCycle: initializeDevCycle,
};
//# sourceMappingURL=index.js.map